import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import api from '../../api/api';
import { OrdersState } from './types';

const initialState: OrdersState = {
  data: [],
  isLoading: false,
  error: {},
};

// Reducers
const resetOrdersStateReducer = () => initialState;

// Thunk Actions
const fetchOrders = createAsyncThunk('orders/fetch', async (params, { rejectWithValue }) => {
  try {
    const response = await api.getOrders();

    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// Create Slice
const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    resetOrdersState: resetOrdersStateReducer,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.isLoading = false;
        // @ts-ignore
        state.error = action.payload;
      });
  },
});

export { fetchOrders };
export const { resetOrdersState } = ordersSlice.actions;
export default ordersSlice.reducer;
